import { useEffect, useRef } from 'react';
import ReactScheduler from "@dhtmlx/trial-react-scheduler";
import "@dhtmlx/trial-react-scheduler/dist/react-scheduler.css";
import CustomLightbox from "./EditorModal";

export default function BasicInitDemo() {
  const schedulerRef = useRef(null);

  useEffect(() => {
    document.title = "DHTMLX React Scheduler | Custom Form";
  }, []);

  const events = [
    { id: 1, classname: "blue", start_date: new Date("2025-08-11T02:00:00Z"), end_date: new Date("2025-08-11T10:20:00Z"), text: "Product Strategy Hike" },
    { id: 2, classname: "blue", start_date: new Date("2025-08-11T12:00:00Z"), end_date: new Date("2025-08-11T16:00:00Z"), text: "Agile Meditation and Release" },
    { id: 3, classname: "violet", start_date: new Date("2025-08-12T06:00:00Z"), end_date: new Date("2025-08-12T11:00:00Z"), text: "Tranquil Tea Time" },
    { id: 4, classname: "green", start_date: new Date("2025-08-12T11:30:00Z"), end_date: new Date("2025-08-12T19:00:00Z"), text: "Sprint Review and Retreat" },
    { id: 5, classname: "violet", start_date: new Date("2025-08-13T01:00:00Z"), end_date: new Date("2025-08-13T03:00:00Z"), text: "Kayaking Workshop" },
    { id: 6, classname: "yellow", start_date: new Date("2025-08-13T06:00:00Z"), end_date: new Date("2025-08-13T08:00:00Z"), text: "Stakeholder Sunset Yoga Session" },
    { id: 7, classname: "green", start_date: new Date("2025-08-13T07:00:00Z"), end_date: new Date("2025-08-13T12:00:00Z"), text: "Roadmap Alignment Walk" },
    { id: 8, classname: "violet", start_date: new Date("2025-08-13T13:00:00Z"), end_date: new Date("2025-08-13T18:00:00Z"), text: "Mindful Team Building" },
    { id: 9, classname: "blue", start_date: new Date("2025-08-14T01:00:00Z"), end_date: new Date("2025-08-14T18:00:00Z"), text: "Cross-Functional Expedition" },
    { id: 10, classname: "yellow", start_date: new Date("2025-08-14T14:00:00Z"), end_date: new Date("2025-08-14T20:00:00Z"), text: "User Feedback Picnic" },
    { id: 11, classname: "blue", start_date: new Date("2025-08-15T03:00:00Z"), end_date: new Date("2025-08-15T08:00:00Z"), text: "Demo and Showcase" },
    { id: 12, classname: "yellow", start_date: new Date("2025-08-15T11:00:00Z"), end_date: new Date("2025-08-15T17:00:00Z"), text: "Quality Assurance Spa Day" },
    { id: 13, classname: "violet", start_date: new Date("2025-08-16T01:00:00Z"), end_date: new Date("2025-08-16T03:00:00Z"), text: "Motion Cycling Adventure" },
    { id: 14, classname: "blue", start_date: new Date("2025-08-16T10:00:00Z"), end_date: new Date("2025-08-16T16:00:00Z"), text: "Competitor Analysis Beach Day" },
    { id: 15, classname: "blue", start_date: new Date("2025-08-17T02:00:00Z"), end_date: new Date("2025-08-17T06:00:00Z"), text: "Creativity Painting Retreat" }
  ];
  useEffect(() => {
    //const scheduler = schedulerRef.current?.instance;
    
  }, []);

  return (
    <div className="demo-container">
      <title>DHTMLX React Scheduler | Custom Edit Form</title>
      <ReactScheduler 
        ref={schedulerRef}
        events={events}
        date={new Date("2025-08-15T00:00:00Z")}
        customLightbox={<CustomLightbox />} />
    </div>
  );
}